export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-5.a596d803.png";